import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  default as ExpertServicesIndex
} from "../../../pages/coordinator/experts/show/services";
import {
  ServicesIndex
} from "../../../pages/coordinator/experts/services";
import {
  default as ProfileIndex
} from "../../../pages/coordinator/experts/show/profile";
import {
  default as ExpertsIndex
} from "../../../pages/coordinator/experts";
import {
  MonitoringServicesIndex
} from "../../../pages/coordinator/experts/services/monitoring";
import { default as NewExpertIndex } from "../../../pages/coordinator/experts/new";
import { default as ProfessionaInformationIndex } from "../../../pages/coordinator/experts/new/professional-information";
import { default as AccountsIndex } from "../../../pages/coordinator/experts/new/accounts";
import { default as EnterpreneurshipsIndex } from "../../../pages/coordinator/experts/new/enterpreneurships";
import { PaymentReportIndex } from "../../../pages/admin/experts/services/payment-report";
import { AssignationsMonitoringIndex } from "../../../pages/coordinator/experts/services/monitoring/assignations";
import { TrackingMonitoringServicesIndex } from "../../../pages/coordinator/experts/services/monitoring/tracking";

export const CoordinatorExpertsRoutes = <Switch>
  <Route
    exact
    path="/v2/coordinator/experts/services/monitoring"
    component={MonitoringServicesIndex} />
  <Route
    path="/v2/coordinator/experts/services/monitoring/assignations"
    component={AssignationsMonitoringIndex} />
  <Route
    path="/v2/coordinator/experts/services/monitoring/tracking"
    component={TrackingMonitoringServicesIndex} />
  <Route
    path="/v2/coordinator/experts/services/:id/payment-report"
    component={PaymentReportIndex} />
  <Route
    exact
    path="/v2/coordinator/experts/services"
    component={ServicesIndex} />
  <Route
    path="/v2/coordinator/experts/:expertId/services"
    component={ExpertServicesIndex} />
  <Route
    path="/v2/coordinator/experts/:expertId/profile"
    component={ProfileIndex} />
  <Route
    exact
    path="/v2/coordinator/experts"
    component={ExpertsIndex} />
  <Route
    exact
    path="/v2/coordinator/experts/new/personal-information"
    component={NewExpertIndex} />
  <Route
    exact
    path="/v2/coordinator/experts/new/:id/personal-information"
    component={NewExpertIndex} />
  <Route
    exact
    path="/v2/coordinator/experts/new/:id/professional-information"
    component={ProfessionaInformationIndex} />
  <Route
    exact
    path="/v2/coordinator/experts/new/:id/accounts"
    component={AccountsIndex} />
  <Route
    exact
    path="/v2/coordinator/experts/new/:id/entrepreneurships"
    component={EnterpreneurshipsIndex} />
</Switch>;
